import {useCallback} from 'react'

import {useSuiContext} from '@s-ui/react-context'
import {TOAST_TYPES, useToast} from '@adv-mt/ui/toast'

export const NOTIFICATIONS = {
  AD_COMPLAINT_SENT: {literal: 'AD_COMPLAINT.COMPLAINT_SENT_NOTIFICATION_TEXT', type: TOAST_TYPES.SUCCESS},
  AD_COMPLAINT_ERROR: {
    literal: 'AD_COMPLAINT.COMPLAINT_SENDING_ERROR_NOTIFICATION_TEXT',
    type: TOAST_TYPES.DESTRUCTIVE
  },
  AD_FAVORITE_ADD_ERROR: {literal: 'COMMON.FAVORITE_ADDED_NOTIFICATION_ERROR', type: TOAST_TYPES.DESTRUCTIVE},
  AD_FAVORITE_DELETE_ERROR: {literal: 'COMMON.FAVORITE_DELETED_NOTIFICATION_ERROR', type: TOAST_TYPES.DESTRUCTIVE},
  CONTACT_FORM_SUBMIT_ERROR: {literal: 'CONTACT_SELLER_V2.FORM.SUBMIT_ERROR_TOAST', type: TOAST_TYPES.DESTRUCTIVE},
  DEALER_FAVORITE_ADDED: {literal: 'COMMON.FAVORITE_DEALER_ADDED_NOTIFICATION_SUCCESS', type: TOAST_TYPES.SUCCESS},
  DEALER_FAVORITE_ADD_ERROR: {
    literal: 'COMMON.FAVORITE_DEALER_ADDED_NOTIFICATION_ERROR',
    type: TOAST_TYPES.DESTRUCTIVE
  },
  DEALER_FAVORITE_DELETED: {literal: 'COMMON.FAVORITE_DEALER_DELETED_NOTIFICATION_SUCCESS', type: TOAST_TYPES.SUCCESS},
  DEALER_FAVORITE_DELETE_ERROR: {
    literal: 'COMMON.FAVORITE_DEALER_DELETED_NOTIFICATION_ERROR',
    type: TOAST_TYPES.DESTRUCTIVE
  },
  // Same notices legacy renders through NotificationsVehicleReservation (Reservation/Init hashes)
  RESERVATION_WRONG_USER: {literal: 'VEHICLE_RESERVATION.WRONG_USER_NOTIFICATION', type: TOAST_TYPES.INFO},
  RESERVATION_NOT_AVAILABLE: {
    literal: 'VEHICLE_RESERVATION.NOT_AVAILABLE_NOTIFICATION_TITLE',
    descriptionLiteral: 'VEHICLE_RESERVATION.NOT_AVAILABLE_NOTIFICATION_DESCRIPTION',
    type: TOAST_TYPES.INFO
  },
  // The only two-line notification here, and the reason `description` exists: legacy
  // showed both halves and the body is what redirects the buyer to the phone, so
  // collapsing it into the title alone would drop the recovery path.
  WHATSAPP_LEAD_ERROR: {
    literal: 'WHATSAPP_LEAD_ERROR.TITLE',
    descriptionLiteral: 'WHATSAPP_LEAD_ERROR.BODY',
    type: TOAST_TYPES.DESTRUCTIVE
  },
  // Same post-favorite lead toast legacy shows (variants/legacy/index.js)
  LEAD_POST_FAVORITE_SUCCESS: {
    literal: 'LEAD_POST_FAVORITE.TOAST.SUCCESS.TITLE',
    descriptionLiteral: 'LEAD_POST_FAVORITE.TOAST.SUCCESS.BODY',
    type: TOAST_TYPES.SUCCESS
  },
  LEAD_POST_FAVORITE_ERROR: {
    literal: 'LEAD_POST_FAVORITE.TOAST.ERROR.TITLE',
    descriptionLiteral: 'LEAD_POST_FAVORITE.TOAST.ERROR.BODY',
    type: TOAST_TYPES.DESTRUCTIVE
  }
}

export const useNotify = () => {
  const {i18n} = useSuiContext()
  const {add: addToast} = useToast()

  return useCallback(
    ({literal, descriptionLiteral, type}) =>
      addToast({
        title: i18n.t(literal),
        ...(descriptionLiteral && {description: i18n.t(descriptionLiteral)}),
        type
      }),
    [addToast, i18n]
  )
}
